var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":"Reset Your Password"}},[_c('ResetForm',{on:{"form-submitted":_vm.submitData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }